<template>
    <v-card style="box-shadow: 0 2px 10px rgba(0, 0, 0, 0.25)" class="d-flex flex-column">
        <v-layout pa-3 class="titleCard" style="flex: 0">
            <v-flex shrink class="d-flex align-center">
                <v-icon large class="white--text mr-3">bar_chart</v-icon>
            </v-flex>
            <v-flex class="text-left" style="font-size: 20px">
                {{ title }} ปี {{ year }}
            </v-flex>
        </v-layout>
        <v-layout pa-7 style="flex: 1">
            <v-flex class="d-flex align-center">
                <div style="width: 100%">
                    <v-layout justify-space-between mb-3 style="width: 100%">
                        <v-flex shrink style="color: #FF5100;">
                            กลุ่มอุตสาหกรรม
                        </v-flex>
                        <v-flex shrink>
                            หน่วย: {{ unit }}
                        </v-flex>
                    </v-layout>
                    <canvas id="MeSeStatusCanvas"></canvas>
                </div>
            </v-flex>
        </v-layout>
    </v-card>
</template>

<script>
    import { Bar } from 'vue-chartjs'

    export default {
        extends: Bar,
        props: ['title','year','chartdata', 'options', 'dataname','unit'],

        mounted() {

            Chart.defaults.global.legend.display = false;

            var MeSeContext = document.getElementById("MeSeStatusCanvas").getContext("2d");
            var MeSeData = {
                labels: this.chartdata,
                datasets: [
                    {
                        label: this.dataname,
                        backgroundColor: '#FF5100',
                        data: this.options,
                    }
                ]
            };

            new Chart(MeSeContext, {
                type: 'horizontalBar',
                data: MeSeData,
            });
        }
    }
</script>

<style scoped>

    * {
        font-size: 13px;
    }

    .titleCard {
        background: #4F4F4F;
        color: #FFFFFF;
    }

</style>
